// extracted by mini-css-extract-plugin
module.exports = {"bedtype-list":"app-javascript-packs-listings-show-___BedTypes__bedtype-list___UeTXB","bedtype-item":"app-javascript-packs-listings-show-___BedTypes__bedtype-item___BW0Md"};